import styled from 'styled-components';

export const IconLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  color: #fff;
  flex-wrap: wrap;
  background-color: var(--red);
  width: 100%;
`;

export const IconLinkWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0;
  width: 150px;
  color: #fff;
  text-decoration: none;

  & span > span > span > svg {
    display: flex;
    padding: 0.1em;
    padding-bottom: 0.3em;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;
    width: 56px !important;
    height: 56px !important;
    &:hover {
      transform: scale(115%);
    }
    @media only screen and (max-width: 960px) {
      width: 36px;
      height: 36px;
    }
  }
`;

export const TextWrapper = styled.span`
  padding-top: 5px;
  text-decoration: none;
  text-align: center;

  @media only screen and (max-width: 640px) {
    font-size: 14px;
  }
`;
